import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const storeProducts = new Vuex.Store(
{
	state:
	{
		products: null,

	},
	mutations:
	{
		store_products (state, products)
		{
			state.products = products;
		},

	},
    getters: {
        getProducts : state => state.products,
    },
	actions:
	{
	}
})